export default __webpack_public_path__ + "static/media/info-icon-black.2fbf8767.svg";